import { Component } from '@angular/core';
import { RouterModule } from '@angular/router';

import { ROUTING_PATH } from '@shared/constants/routingPath';

@Component({
  imports: [RouterModule],
  selector: 'aux-no-protocol-versions-link',
  template: `
    <div class="bg-aux-warn2 p-4">
      Please enter a
      <a class="aux-link inline-block" [routerLink]="[protocolEntryLink]">Protocol</a>
      before adding Site Costs
    </div>
  `,
})
export class NoProtocolVersionsLinkComponent {
  protocolEntryLink = `/${ROUTING_PATH.INVESTIGATOR.INDEX}/${ROUTING_PATH.INVESTIGATOR.PROTOCOL_ENTRY.INDEX}`;
}
